export type LandingLang = 'fr' | 'en';

/**
 * The guest-facing QR landing page's own chrome (not the admin's headline/
 * description/button text, which the admin writes directly). French is the
 * default language for a guest scanning a code; English is a switch away.
 *
 * Deliberately not run through i18next: that instance is scoped to the
 * authenticated app and follows the signed-in user's own preference, but a
 * guest here has no account and no relation to whoever is signed in on this
 * device, so the two must never be coupled.
 */
export const landingStrings: Record<LandingLang, {
  loading: string;
  notFound: string;
  emailOptional: string;
  emailPlaceholder: string;
  phoneOptional: string;
  phonePlaceholder: string;
  consentPrefix: string;
  consentSuffix: string;
  privacyPolicy: string;
  signUp: string;
  thanksPreview: string;
  thanksReal: string;
  sponsoredBy: string;
  visitSponsor: string;
  privacyFooter: string;
  submitFailed: string;
}> = {
  fr: {
    loading: 'Chargement...',
    notFound: 'Code QR introuvable ou page indisponible.',
    emailOptional: 'Courriel (facultatif)',
    emailPlaceholder: 'vous@courriel.com',
    phoneOptional: 'Téléphone (facultatif)',
    phonePlaceholder: '(555) 123-4567',
    consentPrefix: "J'accepte de recevoir des mises à jour et promotions de",
    consentSuffix: "J'ai lu la",
    privacyPolicy: 'Politique de confidentialité',
    signUp: "S'inscrire",
    thanksPreview: '[Aperçu] Voici ce que verront les utilisateurs après leur inscription.',
    thanksReal: 'Merci! Vous aurez de nos nouvelles bientôt.',
    sponsoredBy: 'Commandité par',
    visitSponsor: 'Visiter le site',
    privacyFooter: 'Vos informations sont en sécurité avec nous. Nous ne partageons jamais vos détails sans consentement.',
    submitFailed: "Échec de l'envoi.",
  },
  en: {
    loading: 'Loading...',
    notFound: 'QR code not found or landing page unavailable.',
    emailOptional: 'Email (optional)',
    emailPlaceholder: 'you@email.com',
    phoneOptional: 'Phone (optional)',
    phonePlaceholder: '(555) 123-4567',
    consentPrefix: 'I agree to receive updates and promotions from',
    consentSuffix: 'I have read the',
    privacyPolicy: 'Privacy Policy',
    signUp: 'Sign Up',
    thanksPreview: '[Preview] This is what users will see after submitting.',
    thanksReal: "Thanks! You'll hear from us soon.",
    sponsoredBy: 'Sponsored by',
    visitSponsor: 'Visit website',
    privacyFooter: "Your info is safe with us. We never share your details without consent.",
    submitFailed: 'Failed to submit.',
  },
};
